<script>
  export let sections = [];
  export let activeSection = "";
  export let userEmail = "";
  export let userRole = "";
  export let csrfToken = "";
  export let onSelect = () => {};
</script>

<header class="mb-3 pb-2 border-b border-neutral-200 flex items-center justify-between gap-3 flex-nowrap">
  <div class="flex flex-nowrap gap-1.5 overflow-x-auto min-w-0" role="tablist" aria-label="Main navigation">
    {#each sections as section}
      <button
        type="button"
        role="tab"
        aria-selected={section.id === activeSection}
        class="rounded-full px-3.5 py-1 text-[0.82rem] font-semibold whitespace-nowrap cursor-pointer transition-all duration-150 border focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-brand-500 {section.id === activeSection ? 'bg-brand-500 border-brand-500 text-white shadow-xs' : 'bg-white border-neutral-200 text-neutral-900 hover:bg-neutral-50 hover:text-neutral-950'}"
        on:click={() => onSelect(section.id)}
      >
        {section.label}
      </button>
    {/each}
  </div>
  <div class="inline-flex items-center gap-2.5 flex-nowrap shrink-0">
    {#if userEmail}
      <span class="inline-flex items-center gap-2" data-testid="current-user">
        <span class="text-neutral-900 font-semibold text-[0.82rem]">{userEmail}</span>
        <span class="rounded-full px-2 py-0.5 text-[0.68rem] font-bold uppercase tracking-wider {userRole === 'admin' ? 'bg-brand-500 text-white' : 'bg-neutral-100 text-neutral-600'}">{userRole}</span>
      </span>
    {/if}
    <form class="inline-flex items-center" action="/users/sign_out" method="post" data-turbo="false">
      <input type="hidden" name="_method" value="delete" autocomplete="off" />
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <button type="submit" class="btn-secondary-brand px-3 py-1 text-[0.82rem]">Sign out</button>
    </form>
  </div>
</header>
